import PropTypes from 'prop-types'

import MoleculeTabs, {MoleculeTab, moleculeTabsTypes, moleculeTabsVariants} from '@s-ui/react-molecule-tabs'

import FilterWrapperBasicContentFilter from './Filter.js'

const FilterWrapperBasicTabs = ({filters, group, onChange, value}) => {
  return (
    <MoleculeTabs type={moleculeTabsTypes.FULLWIDTH} variant={moleculeTabsVariants.HIGHLIGHTED}>
      {filters.map(({allSelectionsId, allSelectionsLabel, id, label, name, options, type}, index) => (
        <MoleculeTab numTab={index + 1} label={label} key={id}>
          <FilterWrapperBasicContentFilter
            allSelectionsId={allSelectionsId}
            allSelectionsLabel={allSelectionsLabel}
            group={group}
            id={id}
            label={label}
            name={name}
            onChange={onChange}
            options={options}
            type={type}
            value={value[name]}
            withDivider
          />
        </MoleculeTab>
      ))}
    </MoleculeTabs>
  )
}

FilterWrapperBasicTabs.displayName = 'FilterWrapperBasicTabs'
FilterWrapperBasicTabs.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      allSelectionsId: PropTypes.string,
      allSelectionsLabel: PropTypes.string,
      id: PropTypes.array,
      name: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string,
          nestedItems: PropTypes.arrayOf(
            PropTypes.shape({
              extendedInfo: PropTypes.string,
              icon: PropTypes.node,
              id: PropTypes.string,
              isHighlighted: PropTypes.bool,
              label: PropTypes.string
            })
          )
        })
      ),
      type: PropTypes.string
    })
  ),
  group: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.array
}

export default FilterWrapperBasicTabs
